import { columnTypes } from '@qdabra/forms-shared/sharePoint';
import { includes } from 'ramda';
import { coalesceArray } from '../../utility/arrayHelpers';
import {
    getDateFieldValue,
    getPersonValues,
} from '../../utility/typedFieldHelpers';
import { getFieldHtml } from '../../utility/xmlHelpers';
import {
    selectListFormNode,
    selectListFormNodes,
} from './sharePointListForm.getDsFieldValues';

const {
    SP_TYPE_DATE_TIME,
    SP_TYPE_FULLHTML,
    SP_TYPE_MULTI_CHOICE,
    SP_TYPE_URL,
    SP_TYPE_USER,
    SP_TYPE_USER_MULTI,
} = columnTypes;

// DataSourceNode -> [DataSourceNode]
const getPersonNodes = (fieldNode) =>
    selectListFormNodes(fieldNode, 'pc:Person');

const getMultiValues = (fieldNode) =>
    selectListFormNodes(fieldNode, 'Value').map((field) => field.value());

function getFieldValue(node, xPath, typeLower) {
    if (!xPath) {
        return null;
    }

    const fieldNode = selectListFormNode(node, xPath);
    if (!fieldNode) {
        return null;
    }

    const nodeValue = fieldNode.value();

    switch (typeLower) {
        case SP_TYPE_FULLHTML:
            return getFieldHtml(fieldNode.getNode());

        case SP_TYPE_DATE_TIME:
            var dateValue = getDateFieldValue(nodeValue);

            if (dateValue === '-1') {
                throw new Error(
                    'Could not submit to list, invalid date: ' + nodeValue,
                );
            }

            return dateValue;

        case SP_TYPE_USER:
        case SP_TYPE_USER_MULTI:
            return getPersonValues(getPersonNodes(fieldNode));

        case SP_TYPE_URL:
            return {
                url: nodeValue,
                description: fieldNode.evaluateString('@Description'),
            };

        case SP_TYPE_MULTI_CHOICE:
            return getMultiValues(fieldNode);

        default:
            return nodeValue;
    }
}

const USER_VALUE_TYPES = [SP_TYPE_USER, SP_TYPE_USER_MULTI];

const MULTI_VALUE_TYPES = [...USER_VALUE_TYPES, SP_TYPE_MULTI_CHOICE];

export function createFieldItem(itemNode, field) {
    const internalName = field.internalName;
    const fieldXPath = 'my:' + internalName;

    const fieldType = field.type;
    const isDate = fieldType === SP_TYPE_DATE_TIME;
    const isUrl = fieldType === SP_TYPE_URL;
    const isId = internalName.toLowerCase() === 'id';
    const isFieldUserValue = includes(fieldType, USER_VALUE_TYPES);
    const isMultiValue = includes(fieldType, MULTI_VALUE_TYPES);

    // 53316 - Changed to make values consistently an array
    const values = coalesceArray(
        getFieldValue(itemNode, fieldXPath, fieldType),
    );
    const urlValue = isUrl ? values[0] : null;

    return {
        internalName: !isId ? internalName : null,
        isId,
        isDate,
        isDateTime: isDate,
        isFieldUserValue,
        isMultiValue,
        multiValues: isMultiValue ? values : null,
        isUrl,
        xPath: fieldXPath,
        values: isUrl ? [urlValue.url] : values,
        urlValue: isUrl ? urlValue : null,
    };
}
